import dayjs from 'dayjs'
import IQueries from './index'
import GatewayBase from '../gatewayBase'
import { GatewayError, QueryError } from '../errors'

const RxFunc = /^([A-Za-z0-9_]+)\.([A-Za-z0-9_]+)$/

export default class QueriesCli extends IQueries {
    
    constructor(gateway) {
        super()
        /** @type GatewayBase */
        this.gateway = gateway
    }
    
    convertDate(result) {
      for (let paramI in result) {
        const p = result[paramI]
        if (p.type !== 'CURSOR') continue
        for (let coln in p.value.columns) {
          const colType = p.value.columns[coln][1]
          if (colType === 'DATE') {
            for (let i in p.value.list) {
              const row = p.value.list[i]
              result[paramI].value.list[i][coln] = 
                  (!!row[coln])? dayjs(row[coln]).format('DD.MM.YYYY HH:mm:ss'): null
            }                
          }
        }
      }      
    }

    async queryRaw (queryName, params = {}, count=1, offset=0, options={}) {
        let func = queryName.match(RxFunc)
        if (!func) {
            throw new Error(`Invalid query name format: ${queryName}. Expected package.function`)
        }
        let result = await this.gateway.serverHttp("POST",'ora-queries/exec-func',{
            package: func[1],
            func: func[2],
            params,
            count,
            offset
        })
        result = result.results
        if (options.convertDate) this.convertDate(result)
        console.log('queryFunc', queryName, params, count, offset, result)
        return result
    }
}